module.exports = __webpack_public_path__ + "static/media/icon-search.f19bbc12.svg";